export default function EFNoData(props: any) {
    return (
        <svg width="180" height="138" viewBox="0 0 180 138" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M17.2882 51.2733C17.2882 51.2733 19.3897 45.5403 24.5557 47.7903C25.7482 46.5798 27.2242 45.7001 29.2199 46.0961C31.2157 46.4921 32.5027 47.9883 32.9392 48.9828C33.5647 48.9536 38.5732 49.1201 38.5732 54.3153C38.5732 59.5106 32.5117 59.4116 32.0729 58.9998C31.5329 59.4813 28.9364 62.0936 25.7864 59.1123C25.1047 59.6951 22.8772 62.1633 19.3559 58.7568C17.7247 59.4386 13.8479 59.9628 13.0964 55.9601C12.3449 51.9596 16.1992 50.8301 17.2882 51.2733Z"
                fill="url(#paint0_linear_16_1259)"
            />
            <path
                d="M136.707 25.3518C136.707 25.3518 139.994 16.272 148.075 19.8355C149.94 17.9183 152.249 16.525 155.37 17.1522C158.492 17.7829 160.505 20.1491 161.188 21.7242C162.166 21.6778 170 21.9415 170 30.1697C170 38.3979 160.519 38.2411 159.833 37.589C158.988 38.3516 154.927 42.4889 150 37.7672C148.933 38.6901 145.449 42.5993 139.942 37.2041C137.39 38.2839 131.326 39.1142 130.151 32.7747C128.975 26.4387 135.004 24.6498 136.707 25.3518Z"
                fill="url(#paint1_linear_16_1259)"
            />
            <path
                d="M90.4705 137.227C136.57 137.227 173.941 119.491 173.941 97.6135C173.941 75.7356 136.57 58 90.4705 58C44.371 58 7 75.7356 7 97.6135C7 119.491 44.371 137.227 90.4705 137.227Z"
                fill="url(#paint2_linear_16_1259)"
            />
            <path
                d="M87.1322 57.1712L92.8858 53.2203L92.8522 53.1542C97.7936 50.2723 96.5694 37.7597 90.0359 24.937C83.4099 11.9327 73.832 3.5338 68.6431 6.17767C68.5774 6.21116 68.5124 6.24625 68.4486 6.28278L62.3125 8.4591L63.662 11.1088C68.3674 10.2208 76.2239 17.7671 81.8966 28.9004C87.5693 40.0337 89.0565 50.8254 85.5723 54.1103L87.1322 57.1712Z"
                fill="#B2BECB"
            />
            <path
                d="M64.31 38.0615C71.1793 51.5434 81.1288 60.2406 86.5327 57.4872C91.9365 54.7338 90.7485 41.5724 83.8791 28.0905C77.0097 14.6085 67.0603 5.91136 61.6564 8.66478C56.2525 11.4182 57.4406 24.5795 64.31 38.0615ZM65.5127 37.2485C59.425 25.3006 58.1576 13.7463 62.6819 11.441C67.2062 9.13578 75.8089 16.9526 81.8966 28.9004C87.9843 40.8482 89.2517 52.4026 84.7275 54.7079C80.2032 57.0131 71.6004 49.1963 65.5127 37.2485Z"
                fill="#C9D2E3"
            />
            <mask id="mask0_16_1259" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="59" y="10" width="29" height="46">
                <path
                    d="M81.8967 28.9004C87.9844 40.8482 89.2518 52.4026 84.7275 54.7078C80.2032 57.0131 71.6005 49.1962 65.5128 37.2484C59.4251 25.3006 58.1577 13.7462 62.6819 11.441C67.2062 9.13574 75.809 16.9526 81.8967 28.9004Z"
                    stroke="#060606"
                />
            </mask>
            <g mask="url(#mask0_16_1259)">
                <g filter="url(#filter0_f_16_1259)">
                    <path
                        d="M81.8967 28.9004C87.9844 40.8482 89.2518 52.4026 84.7275 54.7078C80.2032 57.0131 71.6005 49.1962 65.5128 37.2484C59.4251 25.3006 58.1577 13.7462 62.6819 11.441C67.2062 9.13574 75.809 16.9526 81.8967 28.9004Z"
                        stroke="#060606"
                    />
                </g>
            </g>
            <path
                d="M90.88 52.9016C91.7858 52.2906 92.6773 51.9822 93.0319 52.1327L93.0693 52.1075L97.9732 59.3778L99.6122 58.2724L117.014 84.0709L116.994 84.0844C117.033 84.1141 117.066 84.1487 117.093 84.1882C117.502 84.7954 116.262 86.3483 114.322 87.6564C112.383 88.9646 110.479 89.5329 110.069 88.9257C110.042 88.8862 110.023 88.8424 110.009 88.7952L109.99 88.8084L92.5887 63.0102L94.2271 61.9046L89.3232 54.6342L89.3609 54.6088C89.3538 54.2235 89.9738 53.5128 90.88 52.9016Z"
                fill="#B2BECB"
            />
            <mask id="mask1_16_1259" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="89" y="52" width="29" height="38">
                <g opacity="0.423">
                    <path
                        d="M90.88 52.9016C91.7858 52.2906 92.6773 51.9822 93.0319 52.1327L93.0693 52.1075L97.9732 59.3778L99.6122 58.2724L117.014 84.0709L116.994 84.0844C117.033 84.1141 117.066 84.1487 117.093 84.1882C117.502 84.7954 116.262 86.3483 114.322 87.6564C112.383 88.9646 110.479 89.5329 110.069 88.9257C110.042 88.8862 110.023 88.8424 110.009 88.7952L109.99 88.8084L92.5887 63.0102L94.2271 61.9046L89.3232 54.6342L89.3609 54.6088C89.3538 54.2235 89.9738 53.5128 90.88 52.9016Z"
                        fill="#353941"
                    />
                </g>
            </mask>
            <g mask="url(#mask1_16_1259)">
                <path
                    opacity="0.423"
                    d="M80.5505 56.3802L93.4274 47.6947L93.271 51.6392C92.2865 54.3366 91.9583 57.2296 92.3137 60.0789L92.5882 62.2792L80.5505 56.3802Z"
                    fill="#353941"
                />
            </g>
            <path
                d="M127.103 50.8164C127.103 50.8164 128.624 46.6651 132.364 48.2964C133.228 47.4189 134.294 46.7821 135.741 47.0701C137.188 47.3581 138.117 48.4404 138.432 49.1581C138.884 49.1379 142.511 49.2571 142.511 53.0169C142.511 56.7766 138.124 56.7046 137.807 56.4076C137.415 56.7564 135.536 58.6464 133.255 56.4909C132.762 56.9116 131.149 58.7004 128.602 56.2344C127.421 56.7271 124.615 57.1074 124.07 54.2094C123.524 51.3136 126.316 50.4946 127.103 50.8164Z"
                fill="url(#paint3_linear_16_1259)"
            />
            <defs>
                <filter
                    id="filter0_f_16_1259"
                    x="55.4702"
                    y="6.53784"
                    width="36.469"
                    height="53.0731"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_16_1259" />
                </filter>
                <linearGradient id="paint0_linear_16_1259" x1="25.7867" y1="60.5237" x2="25.7867" y2="46.0019" gradientUnits="userSpaceOnUse">
                    <stop offset="0.2332" stopColor="white" />
                    <stop offset="1" stopColor="#D3DFEE" />
                </linearGradient>
                <linearGradient id="paint1_linear_16_1259" x1="150" y1="40.0023" x2="150" y2="17.0028" gradientUnits="userSpaceOnUse">
                    <stop offset="0.2332" stopColor="white" />
                    <stop offset="1" stopColor="#D3DFEE" />
                </linearGradient>
                <linearGradient id="paint2_linear_16_1259" x1="90.4696" y1="137.227" x2="90.4696" y2="57.9981" gradientUnits="userSpaceOnUse">
                    <stop offset="0.526482" stopColor="white" />
                    <stop offset="1" stopColor="#DAE4EF" />
                </linearGradient>
                <linearGradient id="paint3_linear_16_1259" x1="133.255" y1="57.5114" x2="133.255" y2="47" gradientUnits="userSpaceOnUse">
                    <stop offset="0.2332" stopColor="white" />
                    <stop offset="1" stopColor="#D3DFEE" />
                </linearGradient>
            </defs>
        </svg>
    );
}
